/**
 * Types for the member-centric frontend flow.
 *
 * TeamMember comes from the existing useGetTeamQuery() response.
 */

// Re-export TeamMember from apiSlice for convenience
export type { TeamMember } from '../../store/api/apiSlice';

/**
 * Helper to get display name for a team member
 */
export function getMemberDisplayName(member: {
  person: {
    given_name?: string;
    family_name?: string;
    primary_email: string;
  };
}): string {
  const { given_name, family_name, primary_email } = member.person;
  if (given_name || family_name) {
    return `${given_name || ''} ${family_name || ''}`.trim();
  }
  return primary_email;
}
